import { render, staticRenderFns } from "./ClassInstructorList.vue?vue&type=template&id=3c2bac97&"
import script from "./ClassInstructorList.vue?vue&type=script&lang=js&"
export * from "./ClassInstructorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports